export default {
  user: state => state.user,
  device: state => state.device,
}
